//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class ValueSetModel extends ModelBase {
      static readonly $typeName = 'ValueSetModel';
      public conceptCode: string;
      public conceptName: string;
      public conceptVersionKey: string;
      public hasCodesDefined: boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/ValueSetModel.ts